<template>
  <div id="dashboard" class="content" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="row push">
      <div class="col-md-6 col-xl-3">
        <a class="block block-rounded cursor-auto" href="javascript:void(0)">
          <div
            class="block-content block-content-full d-flex align-items-center justify-content-between"
          >
            <div>
              <span
                class="js-sparkline"
                data-type="line"
                :data-points="'['+ orderArr+']'"
                data-width="90px"
                data-height="40px"
                data-line-color="#82b54b"
                data-fill-color="transparent"
                data-spot-color="transparent"
                data-min-spot-color="transparent"
                data-max-spot-color="transparent"
                data-highlight-spot-color="#82b54b"
                data-highlight-line-color="#82b54b"
                data-tooltip-suffix="笔"
              >
                <canvas
                  width="90"
                  height="40"
                  style="display: inline-block; width: 90px; height: 40px; vertical-align: top;"
                ></canvas>
              </span>
            </div>
            <div class="ml-3 text-right">
              <p class="font-size-h3 font-w300 mb-0">{{orderNum.chargeOrder || 0}}</p>
              <p class="text-muted mb-0 font-size-75">充电订单数</p>
            </div>
          </div>
        </a>
      </div>
      <div class="col-md-6 col-xl-3">
        <a class="block block-rounded cursor-auto" href="javascript:void(0)">
          <div
            class="block-content block-content-full d-flex align-items-center justify-content-between"
          >
            <div>
              <span
                class="js-sparkline"
                data-type="line"
                :data-points="'['+ packageOrderArr+']'"
                data-width="90px"
                data-height="40px"
                data-line-color="#e04f1a"
                data-fill-color="transparent"
                data-spot-color="transparent"
                data-min-spot-color="transparent"
                data-max-spot-color="transparent"
                data-highlight-spot-color="#e04f1a"
                data-highlight-line-color="#e04f1a"
                data-tooltip-suffix="笔"
              >
                <canvas
                  width="90"
                  height="40"
                  style="display: inline-block; width: 90px; height: 40px; vertical-align: top;"
                ></canvas>
              </span>
            </div>
            <div class="ml-3 text-right">
              <p class="font-size-h3 font-w300 mb-0">{{orderNum.packageOrder|| 0}}</p>
              <p class="text-muted mb-0 font-size-75">时长包订单数</p>
            </div>
          </div>
        </a>
      </div>
      <div class="col-md-6 col-xl-3">
        <a class="block block-rounded cursor-auto" href="javascript:void(0)">
          <div
            class="block-content block-content-full d-flex align-items-center justify-content-between"
          >
            <div>
              <span
                class="js-sparkline"
                data-type="line"
                :data-points="'['+ totalOrderArr+']'"
                data-width="90px"
                data-height="40px"
                data-line-color="#3c90df"
                data-fill-color="transparent"
                data-spot-color="transparent"
                data-min-spot-color="transparent"
                data-max-spot-color="transparent"
                data-highlight-spot-color="#3c90df"
                data-highlight-line-color="#3c90df"
                data-tooltip-suffix="笔"
              >
                <canvas
                  width="90"
                  height="40"
                  style="display: inline-block; width: 90px; height: 40px; vertical-align: top;"
                ></canvas>
              </span>
            </div>
            <div class="ml-3 text-right">
              <p class="font-size-h3 font-w300 mb-0">{{orderNum.totalOrder || 0}}</p>
              <p class="text-muted mb-0 font-size-75">总订单数(笔)</p>
            </div>
          </div>
        </a>
      </div>
      <div class="col-md-6 col-xl-3">
        <a class="block block-rounded cursor-auto" href="javascript:void(0)">
          <div
            class="block-content block-content-full d-flex align-items-center justify-content-between"
          >
            <div>
              <span
                class="js-sparkline"
                data-type="line"
                :data-points="'['+ validRatioArr+']'"
                data-width="90px"
                data-height="40px"
                data-line-color="#343a40"
                data-fill-color="transparent"
                data-spot-color="transparent"
                data-min-spot-color="transparent"
                data-max-spot-color="transparent"
                data-highlight-spot-color="#343a40"
                data-highlight-line-color="#343a40"
                data-tooltip-suffix="%"
              >
                <canvas
                  width="90"
                  height="40"
                  style="display: inline-block; width: 90px; height: 40px; vertical-align: top;"
                ></canvas>
              </span>
            </div>
            <div class="ml-3 text-right">
              <p class="font-size-h3 font-w300 mb-0">{{orderNum.validRatio || 0}}%</p>
              <p class="text-muted mb-0 font-size-75">总有效订单占比</p>
            </div>
          </div>
        </a>
      </div>
    </div>
    <div class="col-12" style="margin-bottom: 10px;">
      <div class="row mb-2 mt-4" style="margin-right: -64px;">
        <div class="col-6 row">
          <h2 class="h3 font-w400 mb-0 line-height">全部订单</h2>
        </div>
        <div class="col-6 text-right mr-0">
          <screenTime :isToday="'0'" :isBlack="true" @changePage="changePage"></screenTime>
        </div>
      </div>
    </div>
    <div id="dashboard">
      <div class="block block-rounded block-bordered">
        <div class="block-header block-header-default" style="padding: 0;">
          <ul
            class="nav nav-tabs nav-tabs-block nav-main nav-main-horizontal nav-main-hover"
            data-toggle="tabs"
            role="tablist"
          >
            <li class="nav-item" v-for="(item,index) in orderTypeList" :key="index">
              <a
                class="nav-link"
                :class="['btabs-animated-fade-'+item.ORDER_TYPE ,
                [orderTypeList.length>1&&(item.ORDER_TYPE==orderType||index==0)?'active':''],
                [orderTypeList.length==1?' oneTable':'']]"
                href="javascript:void(0)"
                @click="showTab('btabs-animated-fade-'+item.ORDER_TYPE,item.ORDER_TYPE)"
              >{{item.ORDER_NAME}}</a>
            </li>
          </ul>
          <div style="margin-right: 1.25rem">
            <button
              type="button"
              class="btn-block-option"
              data-toggle="block-option"
              data-action="fullscreen_toggle"
            >
              <i class="si si-size-fullscreen"></i>
            </button>
          </div>
        </div>
        <div class="block-content tab-content overflow-hidden">
          <div
            class="tab-pane tab-pane-tab fade"
            id="btabs-animated-fade-1"
            role="tabpanel"
            v-show="isChargeingPageTabs"
            :class="{' show active':isChargeingPageTabs}"
          >
            <chargeingOrder ref="chargeingOrder"></chargeingOrder>
          </div>
          <div
            class="tab-pane tab-pane-tab fade"
            id="btabs-animated-fade-2"
            role="tabpanel"
            v-show="isHistoryPageTabs"
            :class="{' show active':!isChargeingPageTabs && isHistoryPageTabs}"
          >
            <orderHistory ref="orderHistory"></orderHistory>
          </div>
          <div
            class="tab-pane tab-pane-tab fade"
            id="btabs-animated-fade-3"
            role="tabpanel"
            v-show="isPackagePageTabs"
            :class="{' show active':!isChargeingPageTabs&&!isHistoryPageTabs&&isPackagePageTabs}"
          >
            <packageOrder ref="packageOrder"></packageOrder>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Util from "../../../Util.js";
import screenTime from "../../../components/screenTime";
import pageSize from "../../../components/pageSize";

import chargeingOrder from "../../management/user/chagreingOrder";
import orderHistory from "../../management/user/orderHistory";
import packageOrder from "../../management/package/user";

export default {
  name: "index",
  data() {
    return {
      orderType: 1,
      oldOrderTypeList: [
        {
          ORDER_TYPE: "1",
          ORDER_NAME: "在线充电订单",
          SHOW_TAB: Util.isPageTabsPerm("onlineorderPanel")
        },
        {
          ORDER_TYPE: "2",
          ORDER_NAME: "历史充电订单",
          SHOW_TAB: Util.isPageTabsPerm("orderPanel")
        },
        {
          ORDER_TYPE: "3",
          ORDER_NAME: "充电包订单",
          SHOW_TAB: Util.isPageTabsPerm("userPackageList")
        }
      ],
      orderTypeList: [],
      orderNum: {},
      isChargeingPageTabs: Util.isPageTabsPerm("onlineorderPanel"),
      isHistoryPageTabs: Util.isPageTabsPerm("orderPanel"),
      isPackagePageTabs: Util.isPageTabsPerm("userPackageList"),
      orderArr: [],
      packageOrderArr: [],
      totalOrderArr: [],
      validRatioArr: []
    };
  },
  components: {
    screenTime,
    pageSize,
    chargeingOrder,
    orderHistory,
    packageOrder
  },
  computed: {
    duration() {
      return this.$store.state.duration;
    },
    roleName() {
      return this.$store.state.roleName;
    },
    isMobile() {
      return this.$store.state.isMobile;
    },
    pagerCount() {
      return this.$store.state.pagerCount;
    },
    userInfo() {
      return this.$store.state.userInfo;
    },
    params() {
      return this.$store.state.params;
    },
    regionParams() {
      return this.$store.state.regionParams;
    },
    fullscreenLoading() {
      return this.$store.state.fullscreenLoading;
    }
  },
  watch: {
    "$store.state.duration": {
      handler: function(val, oldVal) {
        if (typeof oldVal === "undefined") return;
        if (JSON.stringify(val) != JSON.stringify(oldVal)) {
          this.$refs.chargeingOrder.getList();
          this.$refs.orderHistory.getList();
          this.$refs.packageOrder.getList();
          this.getOrderNum();
        }
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
    if (this.$route.params.type) {
      this.$store.commit("setParam", {
        params: this.$route.params
      });
    }
    this.oldOrderTypeList.find(item => {
      if (item.SHOW_TAB) {
        this.orderTypeList.push(item);
      }
    });
    this.getOrderNum();
  },
  methods: {
    getOrderNum() {
      this.$http
        .get(
          `${Util.searchURL}/User/GetOrderInfo/${this.duration.startDate}/${this.duration.endDate}?region=${this.regionParams.region}&object=${this.regionParams.object}`
        )
        .then(res => {
          if (res.data.code === 200) {
            this.orderNum = res.data.data;
            this.orderArr = [];
            this.packageOrderArr = [];
            this.totalOrderArr = [];
            this.validRatioArr = [];
            if (res.data.data) {
              let log = res.data.data.log;
              log.find(d => {
                this.orderArr.push(Number(d.orderNum));
                this.packageOrderArr.push(Number(d.pacageOrderNum));
                this.totalOrderArr.push(Number(d.totalOrderNum));
                this.validRatioArr.push(Number(d.validRatio));
              });
            }
            $(function() {
              Dashmix.helpers([
                "easy-pie-chart",
                "sparkline",
                "datepicker",
                "flatpickr"
              ]);
            });
            this.$store.commit("setParam", {
              fullscreenLoading: false
            });
          }
        });
    },
    changePage(val) {
      this.page = val;
    },
    changePageSize(val) {
      this.pageSize = val;
      this.page = 1;
    },
    changeTwoDecimal(val) {
      return Util.changeTwoDecimal(val);
    },
    showTab(el, type) {
      this.orderType = type;
      $(`.${el}`).tab("show");
      for (let i of $(`.tab-pane`)) {
        i.className = "tab-pane fade";
      }
      $(`#${el}`).tab("show");
      if (type == 1) {
        this.$refs.chargeingOrder.getList();
      } else if (type == 2) {
        this.$refs.orderHistory.getList();
      } else if (type == 3) {
        this.$refs.packageOrder.getList();
      }
    }
  }
};
</script>